import React from 'react';

class About extends React.Component {
    render() {
        return (
            <section className="bg-primary" id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <h2 className="section-heading text-white">
                                <strong>We Are Novotec.</strong><br/>
                                <small><em>no·vo·tec</em> - /novōˌtek/</small>
                            </h2>
                            <hr className="light my-4"/>
                            <p className="text-faded mb-4">
                                <strong>no·vo</strong> /novō/ : 1. make new, renovate; 2. renew, refresh, change.
                                <br/>
                                <strong>tec</strong> /tek/ : 1. technology
                            </p>
                            <p className="text-faded mb-4">
                                Our passion is technology and our mission is to help our clients solve complex problems
                                with exciting new software and industry practices. What we bring to the table are
                                skilled technologists to mold bleeding-edge technologies into the right solution for
                                you.
                            </p>
                            <hr className="light my-4"/>
                            <br/>
                            <a className="btn btn-light btn-xl js-scroll-trigger" href="#services">
                                How We Can Help
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/js/App/About/About.js